'use strict';

// Helpers para cargar vistas de forma compatible con Vite

// Importante: import.meta.glob NO soporta alias como '@'.
// Como el root de Vite es 'client', la ruta absoluta correcta es '/src/**'.
// También añadimos el patrón relativo desde este archivo por robustez.
const viewModules = {
  ...import.meta.glob('/src/views/**/*.vue'),
  ...import.meta.glob('../views/**/*.vue'),
};

/**
 * Carga perezosa de una vista usando import.meta.glob
 * @param {string} path Ej. 'main/login' o 'accounts/index' (con o sin .vue)
 */
const view = (path) => {
  const normalized = path.replace(/\.vue$/, '');
  const candidates = [
    `/src/views/${normalized}.vue`,
    `../views/${normalized}.vue`,
  ];

  for (const key of candidates) {
    if (key in viewModules) {
      // Import dinámico: devolver la Promesa que espera Vue Router
      return viewModules[key]();
    }
  }

  // Si no se encuentra, ayudamos a depurar con un error claro
  throw new Error(`View not found for path: ${path}. Tried: ${candidates.join(', ')}`);
};

export { view };